function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { LapelError } from "../logger";
import chunked from "./chunked";
import debounce from "./debounce";
import { getGlobalLapel } from "./debug";
import { subscribe, publish } from "./pubsub";
export var STATUS_NEW = "new";
export var STATUS_PENDING = "pending";
export var STATUS_RESOLVED = "resolved";
export var STATUS_REJECTED = "rejected";
var AsyncCache = /*#__PURE__*/ function() {
    "use strict";
    function AsyncCache(param) {
        var id = param.id, getKey = param.getKey, _param_onAdd = param.onAdd, onAdd = _param_onAdd === void 0 ? function(item) {
            return item;
        } : _param_onAdd, beforeExecute = param.beforeExecute, onExecute = param.onExecute, _param_debounceTime = param.debounceTime, debounceTime = _param_debounceTime === void 0 ? null : _param_debounceTime, _param_enabled = param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, _param_chunkSize = param.chunkSize, chunkSize = _param_chunkSize === void 0 ? 50 : _param_chunkSize;
        this.enabled = enabled;
        this.locks = {};
        this.id = id;
        this.getKey = getKey;
        this.onAdd = onAdd;
        this.beforeExecute = beforeExecute;
        this.onExecute = onExecute;
        this.chunkSize = chunkSize;
        this.data = {};
        if (debounceTime !== null) {
            this.execute = debounce(this.executeImmediate.bind(this), debounceTime);
        } else {
            this.execute = this.executeImmediate.bind(this);
        }
        var lapel = getGlobalLapel();
        if (Object.prototype.hasOwnProperty.call(lapel, "caches") === false) {
            lapel.caches = {};
        }
        lapel.caches[id] = this;
    }
    var _proto = AsyncCache.prototype;
    /* 
    @param {String} key - Key is used to create a named lock, when unlocking if the key is not present, we do nothing
  */ _proto.lock = function lock(key) {
        this.enabled = false;
        this.locks[key] = (this.locks[key] || 0) + 1;
    };
    _proto.unlock = function unlock(key) {
        this.locks[key] = Math.max(0, (this.locks[key] || 0) - 1);
        var totalLocks = Object.values(this.locks).reduce(function(a, b) {
            return a + b;
        }, 0);
        if (totalLocks === 0) {
            this.enabled = true;
            this.execute();
        }
    };
    _proto.add = function add(item) {
        var key = this.getKey(item, {
            cache: this
        });
        if (Object.prototype.hasOwnProperty.call(this.data, key) === false) {
            this.data[key] = _extends({
                status: STATUS_NEW
            }, this.onAdd(item, key, {
                cache: this
            }), {
                createdAt: Date.now()
            });
            // This allows onAdd to resolve an item immediately
            if (this.data[key].status !== STATUS_NEW) {
                publish(this.id + "-cache-" + key + "-update", this.data[key]);
            }
        }
        return this.data[key];
    };
    _proto.subscribe = function subscribe1(item, callback) {
        var key = this.getKey(item, {
            cache: this
        });
        var un = subscribe(this.id + "-cache-" + key + "-update", function(cachedItem) {
            callback(cachedItem, un);
        });
        var cachedItem = this.add(item);
        if (cachedItem.status === STATUS_RESOLVED) {
            callback(cachedItem, un);
        }
        return un;
    };
    _proto.remove = function remove(item) {
        var key = this.getKey(item, {
            cache: this
        });
        delete this.data[key];
        publish(this.id + "-cache-" + key + "-update", null);
    };
    _proto.clear = function clear() {
        var _this = this;
        Object.keys(this.data).forEach(function(key) {
            delete _this.data[key];
            publish(_this.id + "-cache-" + key + "-update", null);
        });
        publish("" + this.id + "-cache-cleared");
    };
    _proto.get = function get(item) {
        var key = this.getKey(item, {
            cache: this
        });
        if (this.data[key]) {
            return _extends({}, item, this.data[key]);
        }
        return null;
    };
    _proto.isEmpty = function isEmpty() {
        return Object.keys(this.data).length === 0;
    };
    _proto.executeChunkImmediate = function executeChunkImmediate(chunk) {
        var _this = this;
        return _async_to_generator(function() {
            var results, error, message;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this.enabled) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _this.onExecute(chunk, {
                                cache: _this
                            })
                        ];
                    case 2:
                        results = _state.sent();
                        // resolve items that came back from onExecute
                        results.forEach(function(item) {
                            var key = _this.getKey(item, {
                                cache: _this
                            });
                            var cachedItem = _this.data[key];
                            if (cachedItem && cachedItem.status === STATUS_PENDING) {
                                Object.assign(cachedItem, _extends({}, item, {
                                    status: STATUS_RESOLVED,
                                    resolvedAt: Date.now()
                                }));
                                publish(_this.id + "-cache-" + key + "-update", cachedItem);
                            }
                        });
                        // resolve items that had no updates from onExecute
                        chunk.forEach(function(item) {
                            var key = _this.getKey(item, {
                                cache: _this
                            });
                            var cachedItem = _this.data[key];
                            if (cachedItem && cachedItem.status === STATUS_PENDING) {
                                Object.assign(cachedItem, {
                                    status: STATUS_RESOLVED,
                                    resolvedAt: Date.now()
                                });
                                publish(_this.id + "-cache-" + key + "-update", cachedItem);
                            }
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        message = error.message;
                        // Reject cache items, something went wrong;
                        chunk.forEach(function(item) {
                            var key = _this.getKey(item, {
                                cache: _this
                            });
                            var cachedItem = _this.data[key];
                            if (cachedItem && cachedItem.status === STATUS_PENDING) {
                                Object.assign(cachedItem, {
                                    status: STATUS_REJECTED,
                                    errorMessage: message
                                });
                                publish(_this.id + "-cache-" + key + "-update", cachedItem);
                            }
                        });
                        throw error;
                    case 4:
                        return [
                            2,
                            true
                        ];
                }
            });
        })();
    };
    _proto.executeImmediate = function executeImmediate() {
        var _this = this;
        return _async_to_generator(function() {
            var pending, chunks, requests, results, errored, hasErrors, requestErrors, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this.enabled) {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            publish("" + _this.id + "-cache@execute-begin")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.beforeExecute(_this.data, {
                                cache: _this
                            })
                        ];
                    case 2:
                        _state.sent();
                        pending = Object.values(_this.data).reduce(function(acc, item) {
                            if (item.status === STATUS_NEW) {
                                item.status = STATUS_PENDING;
                                acc.push(item);
                            }
                            return acc;
                        }, []);
                        if (pending.length === 0) {
                            publish("" + _this.id + "-cache@execute-completed", false);
                            return [
                                2,
                                false
                            ];
                        }
                        chunks = Array.from(chunked(pending, _this.chunkSize));
                        requests = chunks.map(function(chunk) {
                            return _this.executeChunkImmediate(chunk);
                        });
                        return [
                            4,
                            Promise.allSettled(requests)
                        ];
                    case 3:
                        results = _state.sent();
                        errored = results.filter(function(result) {
                            return result.status === "rejected";
                        });
                        hasErrors = errored.length > 0;
                        if (hasErrors) {
                            requestErrors = errored.map(function(result) {
                                return result.reason;
                            });
                            error = new LapelError("Some cache requests failed");
                            publish("" + _this.id + "-cache@execute-errored", error, requestErrors);
                        }
                        publish("" + _this.id + "-cache@execute-completed", !hasErrors);
                        return [
                            2,
                            !hasErrors
                        ];
                }
            });
        })();
    };
    AsyncCache.isDone = function isDone(param) {
        var status = param.status;
        return !(status === STATUS_NEW || status === STATUS_PENDING);
    };
    return AsyncCache;
}();
export { AsyncCache as default };

//# sourceMappingURL=AsyncCache.js.map